import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export const useQuotation = defineStore('quotation', {
  state: () => ({}),
  actions: {
    async getQuotationModelPage(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/quotationModel/page',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    async getQuotationModelInfo(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/quotationModel/info/${id}`,
          method: 'get'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    async createQuotationModel(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/quotationModel/create',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    async updateQuotationModel(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/quotationModel/update',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    async deleteQuotationModel(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/quotationModel/del/${id}`,
          method: 'post'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    async checkAreaConflict(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/quotationModel/checkAreaConflict',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    // 报价记录列表
    async getQuotationRecordPage(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/quotationRecord/page`,
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 报价记录详情
    async getQuotationRecordDetail(id: string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/quotationRecord/info/${id}`,
          method: 'get'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 删除报价记录
    async quotationRecordDel(id: string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/quotationRecord/del/${id}`,
          method: 'post'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
